import type {
  ColorPalette,
  PaletteColorName,
} from '@/features/colors/color.types';
import { PALETTE_COLOR_NAMES } from '@/features/colors/palettes';
import { SimpleGrid } from '@/ui';
import { ColorSwatch } from './ColorSwatch';

type Props = {
  palette: ColorPalette;
  value: PaletteColorName;
  onChange: (color: PaletteColorName) => void;
  onPreview: (color: PaletteColorName | null) => void;
};

/**
 * The accent swatches as one control, so the grid takes the same
 * value/onChange/onPreview binding every other customize control does rather
 * than wiring each swatch at the call site.
 */
export const AccentColorGrid = ({
  palette,
  value,
  onChange,
  onPreview,
}: Props) => (
  <SimpleGrid columns={8} gap="7px">
    {PALETTE_COLOR_NAMES.map((colorName) => (
      <ColorSwatch
        color={palette.colors[colorName].shade['500']}
        isActive={value === colorName}
        key={colorName}
        onClick={() => onChange(colorName)}
        onHoverEnd={() => onPreview(null)}
        onHoverStart={() => onPreview(colorName)}
      />
    ))}
  </SimpleGrid>
);
